import React, { useState } from 'react';
import styles from './search-form.module.scss';

function SearchForm() {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [searchLink, setSearchLink] = useState<string>('/posts');
  const [searchText, setSearchText] = useState<string>('همه');
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

  const toggleDropdown = () => {
    setDropdownOpen(_do => !_do);
  };

  const searchTermChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const selectSearchLink = (link: string, text: string) => {
    setSearchText(text);
    setSearchLink(link);
    setDropdownOpen(false);
  };

  return (
    <form id="top-search-form" className={styles.topSearchForm} action={searchLink}>
      <div className={styles.formInputs}>
        <div className={styles.selectContainer + ' my-dropdown'}>
          <div className={styles.select + ' my-dropdown-toggler'} role="button" onClick={toggleDropdown}>
            <div className={styles.selectSelected}>{searchText}</div>
            <i className="fa fa-chevron-down" />
          </div>
          {dropdownOpen ? (
            <>
              <div className="my-dropdown-overlay" onClick={toggleDropdown} />
              <div id="search-action-dropdown" className={styles.selectOptions + ' my-dropdown-items'}>
                <div className={styles.selectOption + ' my-dropdown-item'} onClick={() => selectSearchLink("/posts", "همه")}>همه</div>
                <div className={styles.selectOption + ' my-dropdown-item'} onClick={() => selectSearchLink("/texts", "تکست ها")}>تکست ها</div>
                <div className={styles.selectOption + ' my-dropdown-item'} onClick={() => selectSearchLink("/beats", "بیت ها")}>بیت ها</div>
                <div className={styles.selectOption + ' my-dropdown-item'} onClick={() => selectSearchLink("/maquettes", "ماکت ها")}>ماکت ها</div>
                {/*<div className={styles.selectOption + ' my-dropdown-item'} onClick={() => selectSearchLink("/studios", "استودیو ها")}>استودیو ها</div>*/}
                {/*<div className={styles.selectOption + ' my-dropdown-item'} onClick={() => selectSearchLink("/artists", "آرتیست ها")}>آرتیست ها</div>*/}</div>
            </>
          ) : ''}
        </div>
        <div className={styles.inputContainer}>
          <input className="form-control" placeholder="دنبال چه چیزی هستید؟" name="s" value={searchTerm} onChange={searchTermChange} />
          <i className="fa fa-search" />
        </div>
      </div>
    </form>

  );
}

export default SearchForm;